export enum AppPages {
  RootPage = "/",
  HomePage = "/",
  NotFoundPage = "*",
}
